let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("9LI4y"), load("iQkbX")]).then(() => parcelRequire('5rq0t'));